import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import * as flights from 'core/flights';
import * as i18next from 'i18next';
// eslint-disable-next-line @typescript-eslint/no-var-requires
const WithRender = require('./template.html');

@WithRender
@Component
export class CoachSchemaComponent extends Vue {
    @Prop()
    reservation: flights.ReservationModel;

    @Prop()
    coach: flights.CoachModel;

    @Prop()
    svgSchema: string;

    selectedElementsQueue: Element[] = [];

    tooltipShowTimer: any = null;

    mounted() {
        const coachPlaceElements = this.$el.querySelectorAll('.coach-place-svg');

        this.coach.selectedPlacesQueue.forEach((place) => {
            const accordingPlaceElement = Array.from(coachPlaceElements).find(placeElement => placeElement['dataset'].number == place.number);

            if (accordingPlaceElement) {
                this.selectedElementsQueue.push(accordingPlaceElement);
            }
        });

        coachPlaceElements.forEach((element) => {
            const placeNumber = element['dataset'].number as string;
            const placeType = element['dataset'].placeType as string;
            const freePlace = this.coach.places.find(place => place.number == placeNumber);

            element.addEventListener('click', () => {
                if (!freePlace || !freePlace.selected) {
                    let tooltipContent: string;

                    window.clearTimeout(this.tooltipShowTimer);
                    if (freePlace) {
                        tooltipContent = `${i18next.t(`label_coach_place_${placeType.toLowerCase()}`)}, ${this.$options.filters?.price(freePlace.fare.amount)}`;
                    } else {
                        tooltipContent = `${i18next.t('label_occupied')}`;
                    }
                    this.$emit('show-tooltip', tooltipContent);
                    this.tooltipShowTimer = setTimeout(() => {
                        this.$emit('hide-tooltip');
                    }, 3000);
                }
            });

            if (!freePlace) {
                element.classList.add('coach-place-svg_occupied');
            }

            if (freePlace) {
                if (freePlace.selected) {
                    element.classList.add('coach-place-svg_selected');
                }

                element.addEventListener('click', () => {
                    freePlace.selected = !freePlace.selected;
                    if (freePlace.selected) {
                        element.classList.add('coach-place-svg_selected');
                        this.selectedElementsQueue.push(element);
                        this.coach.selectedPlacesQueue.push(freePlace);
                    }

                    if (!freePlace.selected) {
                        element.classList.remove('coach-place-svg_selected');
                        this.selectedElementsQueue = this.selectedElementsQueue.filter(queuedPlaceElement => queuedPlaceElement != element);
                        this.coach.selectedPlacesQueue = this.coach.selectedPlacesQueue.filter(queuedPlace => queuedPlace.number != freePlace.number);
                    }

                    if (this.coach.selectedPlacesCount > this.reservation.passengersWithSeatCount
                        && this.coach.selectedPlacesQueue.length) {
                        this.selectedElementsQueue[0].classList.remove('coach-place-svg_selected');
                        this.selectedElementsQueue.shift();
                        this.coach.selectedPlacesQueue[0].selected = false;
                        this.coach.selectedPlacesQueue.shift();
                    }
                });
            }
        });
    }
}
